module.exports = __webpack_public_path__ + "static/media/shape1_0.d5f657a8.obj";